import React from 'react';
import Avatar from '@mui/material/Avatar';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  userBadge: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
  },
  userName: {
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const getInitial = (name: string) => name.charAt(0).toUpperCase();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const UserBadge = ({ firstName, lastName, imageUrl }: {
  firstName: string;
  lastName: string;
  imageUrl: string;
}) => {
  const classes = useStyles();

  const fullName = `${firstName} ${lastName}`;
  const initials = `${getInitial(firstName)}${getInitial(lastName)}`;

  return (
    <div className={classes.userBadge}>
      <Avatar alt={fullName}>{initials}</Avatar>
      <p className={classes.userName}>{fullName}</p>
    </div>
  );
};

export default UserBadge;